import React from 'react';

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import DeleteIcon from '@mui/icons-material/Delete';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import EditIcon from '@mui/icons-material/Edit';
import { IconButton, Stack, TableCell, TableRow } from '@mui/material';

import ConfirmButton from '~/components/Common/Elements/ConfirmButton';

import ReservationSchedule from '../common/ReservationSchedule';

export function RoomRateInclusionSortableItem({
  roomRateInclusion,
  unit,
  onDelete,
  onEdit,
}: {
  roomRateInclusion: App.RoomRateInclusion;
  unit: string;
  onDelete: (inclusion: App.RoomRateInclusion) => void;
  onEdit: (inclusion: App.RoomRateInclusion) => void;
}) {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: roomRateInclusion.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <TableRow
      className="sortable-table-tr"
      key={roomRateInclusion.id}
      data-list-order={roomRateInclusion.order}
      ref={setNodeRef}
      style={style}
      {...attributes}
    >
      <TableCell>
        <IconButton
          {...listeners}
          sx={{
            cursor: 'grab',
          }}
          size="small"
        >
          <DragIndicatorIcon />
        </IconButton>
      </TableCell>
      <TableCell sx={{ display: 'none' }}>{roomRateInclusion.id}</TableCell>
      <TableCell>{roomRateInclusion.description}</TableCell>
      <TableCell>{roomRateInclusion.amount}</TableCell>
      <TableCell>{roomRateInclusion.currency}</TableCell>
      <TableCell>{roomRateInclusion.minimum_los}</TableCell>
      <TableCell>{roomRateInclusion.maximum_los}</TableCell>
      <TableCell>{unit}</TableCell>
      <TableCell>{roomRateInclusion.is_bonus ? 'Yes' : 'No'}</TableCell>
      <TableCell>{roomRateInclusion.lux_plus_tier === 'base' ? 'Yes' : 'No'}</TableCell>
      <TableCell>
        {roomRateInclusion.schedules_list && <ReservationSchedule parent={roomRateInclusion as any} />}
      </TableCell>
      <TableCell>
        <Stack direction="row-reverse">
          <ConfirmButton
            title="Delete"
            confirmTitle="Confirm delete"
            confirmQuestion="Are you sure?"
            confirmAnswer="Delete"
            onConfirm={() => onDelete(roomRateInclusion)}
            size="small"
            asIcon
          >
            <DeleteIcon />
          </ConfirmButton>

          <IconButton title="Edit" onClick={() => onEdit(roomRateInclusion)} size="small">
            <EditIcon />
          </IconButton>
        </Stack>
      </TableCell>
    </TableRow>
  );
}
